<template>
  <v-dialog v-model="dialog" width="900" persistent>
    <v-card class="import-coming-soon">
      <v-row class="no-gutters fill-height">
        <v-col :xs="6" :sm="6" :md="6" :lg="6" align="center" class="fill-height margin-auto">
          <v-row justify="center" class="py-4">
            <span class="font-weight-black font-weight-italic display-2">
              Coming Soon
            </span>
          </v-row>
          <v-row justify="center" class="pt-4">Click the below button to get notified once live </v-row>
          <v-row justify="center" class="my-2">
            <v-btn color="button-primary" class="white--text" @click="$emit('notify-me', true)">
              <span class="font-weight-bold fs-15">Get notified</span>
            </v-btn>
            <v-btn color="info mx-2" class="white--text" @click="$emit('close-coming-soon-modal', true)">
              <span class="font-weight-bold fs-15">close</span>
            </v-btn>
          </v-row>
        </v-col>
        <v-col :xs="6" :sm="6" :md="6" :lg="6">
          <v-img src="/img/comingSoonPage.png" lazy-src="/img/comingSoonPage.png" cover />
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
// import GauravImpexLogo from "@/components/GauravImpexLogo";
// import * as AT from "../store/actionTypes";
// import { SNACKBAR } from "@/store/actionTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "ComingSoonModal",
  components: {
    // GauravImpexLogo
  },
  data() {
    return {
      dialog: true,
      ShowComingSoonModal: true
    };
  },
  mixins: [commonMethodsMixin],
  methods: {}
};
</script>
<style lang="scss">
.login-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.import-coming-soon .margin-auto {
  margin: auto;
}
</style>
